/**
 * @desc 生成沃尔玛货件标签
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: defs.wms.CreateShipmentLabelRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/common/createShipmentLabel`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
